'use client';

import React from 'react';
import { Card, Box, Typography, Fade } from '@mui/material';
import { formatNumber } from './data';

export function KpiCard({ title, value, subtitle, icon, color, bgColor, delay = 0 }) {
    return (
        <Fade in={true} timeout={600} style={{ transitionDelay: `${delay}s` }}>
            <Card
                elevation={0}
                sx={{
                    p: 2,
                    borderRadius: 0.5,
                    backgroundColor: 'white',
                    border: `1px solid ${color}20`,
                    transition: 'box-shadow 0.3s ease-in-out',
                    '&:hover': {
                        boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1), 0px 4px 6px -2px rgba(0,0,0,0.05)',
                    },
                    height: '120px',
                    width: '100%',
                    minWidth: 230,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>

                    {/* Section Texte (Titre, Valeur, Sous-titre) */}
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: 500,
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em',
                                mb: 0.5,
                                color: '#888',
                                display: 'block'
                            }}
                        >
                            {title}
                        </Typography>

                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 'bold',
                                color: '#1a1a2e',
                                fontFamily: "'Cormorant Garamond', serif",
                                fontSize: '1.875rem', // Équivalent à text-3xl
                                lineHeight: 1.2
                            }}
                        >
                            {typeof value === 'number' ? formatNumber(value) : value}
                        </Typography>

                        {subtitle && (
                            <Typography
                                variant="caption"
                                sx={{
                                    mt: 0.5,
                                    color: '#999',
                                    display: 'block',
                                    fontSize: '0.75rem' // Équivalent à text-xs
                                }}
                            >
                                {subtitle}
                            </Typography>
                        )}
                    </Box>

                    {/* Section Icône */}
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: 3,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            backgroundColor: bgColor,
                            color: color,
                            '& svg': {
                                width: 24,
                                height: 24
                            }
                        }}
                    >
                        {icon}
                    </Box>

                </Box>
            </Card>
        </Fade>
    );
}